const ROLE_LABEL_KEYS = {
    executor: "delorean_role_executor",
    claimant: "delorean_role_claimant",
    destination_account_holder: "delorean_role_destination_account_holder",
}

const ROLE_COUNTER_FIELDS = [
    { field: "occurrences_as_executor", labelKey: "delorean_occurrences_as_executor" },
    { field: "occurrences_as_claimant", labelKey: "delorean_occurrences_as_claimant" },
    { field: "occurrences_as_destination_account_holder", labelKey: "delorean_occurrences_as_destination_account_holder" },
]

export const formatConsultedDocumentRoles = (roles, t) => {
    if (!Array.isArray(roles)) return "-"
    if (roles.length === 0) return t("delorean_role_not_identified")
    return roles
        .map((role) => (ROLE_LABEL_KEYS[role] ? t(ROLE_LABEL_KEYS[role]) : String(role)))
        .join(", ")
}

export const formatFraudReason = (fraudReason) => {
    if (typeof fraudReason !== "string") return "-"
    const trimmed = fraudReason.trim()
    return trimmed.length > 0 ? trimmed : "-"
}

export const getDeloreanRoleCounters = (deloreanData) => {
    if (!deloreanData) return null
    const hasAnyCounter = ROLE_COUNTER_FIELDS.some(({ field }) => typeof deloreanData[field] === "number")
    if (!hasAnyCounter) return null
    return ROLE_COUNTER_FIELDS.map(({ field, labelKey }) => ({
        field,
        labelKey,
        value: typeof deloreanData[field] === "number" ? deloreanData[field] : "-",
    }))
}
